"use strict"

// 活動量が単独で高いフレームの最長連続区間を返す（話者識別クリップ選定用）
export const findLongestHighFrame = (activity, member, thresh_single = 0.5, thresh_ratio = 0.9) => {
  const arr = activity[member]
  const T = arr.length
  const flag = new Array(T).fill(false)
  for (let t = 0; t < T; t++) {
    const v = arr[t]
    const total = Object.values(activity).reduce((s, a) => s + a[t], 0)
    if (total === 0) continue
    if (v > thresh_single && v / total > thresh_ratio) flag[t] = true
  }

  let maxLen = 0, maxStart = -1
  let curLen = 0, curStart = 0
  for (let i = 0; i < T; i++) {
    if (flag[i]) {
      if (curLen === 0) curStart = i
      curLen++
      if (curLen > maxLen) { maxLen = curLen; maxStart = curStart }
    } else {
      curLen = 0
    }
  }
  if (maxLen === 0) return null
  return {start: maxStart, end: maxStart + maxLen - 1}
}

export const isDiscussionAudioSaveDisabled = (discussion) => {
  const options = discussion?.options || {}
  return !!(options.isPrivate || options.omitFullChannelAudio)
}

export const isSkillAnalysisVisible = ({skillEnabled, skillAdminOnly = true, isAdmin = false}) => {
  if(!skillEnabled) return false
  if(skillAdminOnly && !isAdmin) return false
  return true
}

export const getDiscussionBehaviorBlockedReasonKey = ({discussion, isDefaultCourse, skillEnabled = false, skillAdminOnly = true, isAdmin = false}) => {
  if(!isSkillAnalysisVisible({skillEnabled, skillAdminOnly, isAdmin})) {
    if(!skillEnabled) return "DiscussionBehavior.BlockedUnavailableOrg"
    return "DiscussionBehavior.BlockedAdminOnly"
  }
  const status = discussion?.status
  const isPrivate = isDiscussionAudioSaveDisabled(discussion)
  if(isPrivate) return "DiscussionBehavior.BlockedNoAudio"
  if(isDefaultCourse) return "DiscussionBehavior.BlockedUnregisteredCourse"
  if(status !== "completed") return "DiscussionBehavior.BlockedUntilCompleted"
  return null
}
